module.exports = __webpack_public_path__ + "static/media/ToT-top.5040fa46.png";


//////////////////
// WEBPACK FOOTER
// ./src/routes/OnboardingDemo/assets/ToT-top.png
// module id = 1267
// module chunks = 0